import { TField } from "../components/forms/DynamicForm"

export const TRANSACTIONAL_REPORT_COLUMNS = {
    'Sr. No.': '',
    'GlobalTransactionNo': '',
    'GT Date': '',
    'TransactionLocationName': '',
    'PVC code': '',
    'PVC Secondary Location code': '',
    'TransactionType': '',
    'GMS Bank Name': '',
    'CustomerName': '',
    'CustomerMTS Reference number': '',
    'Customer Oracle reference number': '',
    'CustomerCity': '',
    'CustomerState': '',
    'CustomerStateCode': '',
    'Customer Accounting StateCode': '',
    'CustomerGSTIN': '',
    'Customer PAN': '',
    'Customer TAN': '',
    'Customer Mobile No.': '',
    'Secondary Customer Name': '',
    'TransactionLocationCity': '',
    'TransactionLocationState': '',
    'TransactionLocationStateCode': '',
    'TransactionLocationGSTIN': '',
    'SecondaryTransactionLocationCity': '',
    'SecondaryTransactionLocationState': '',
    'SecondaryTransactionLocationStateCode': '',
    'SecondaryTransactionLocationGSTIN': '',
    'TransactionHSNCode': '',
    'ConversionPurity': '',
    'CustomerDeclaredWeight': '',
    'WBM': '',
    'WAM': '',
    'WAMT': '',
    'CTWNetWeight': '',
    'CTWFineWeight': '',
    'BuffingDustNetWeight': '',
    'BuffingDustFineWeight': '',
    'Deduction Percentage': '',
    'SettlementNetWeight': '',
    'Fineness': '',
    'FineWeightBeforeDeduction': '',
    'SettlementFineWeight': '',
    'FinalSettlementNetWeight': '',
    'ProductName': '',
    'Product Details': '',
    'Purchase Quantity': '',
    'DocumentName': '',
    'DocumentDate': '',
    'Item Name': '',
    'Product Name': '',
    'Quantity': '',
    'Net weight': '',
    'Fine weight': '',
    'Metal Type' : '',
    'Line Item Type' : '',
    'PreTaxAmount': '',
    'GST%': '',
    'TaxAmount': '',
    'CGST': '',
    'SGST': '',
    'IGST': '',
    'Kerala Flood Cess': '',
    'TCS': '',
    'TaxType': '',
    'Customer TCS': '',
    'TotalAmount': '',
    'TDS%': '',
    'TDSValue': '',
    'Customer TDS': '',
    'Gross Invoice Value': '',
    'Net Payable to Customer': '',
    'Net Receivable to Customer': '',
    'Tax Category': '',
    'DeliveryChallan': '',
    'TaxInvoice': '',
    'PurchaseReciept': '',
    'GMSReceipt': '',
    'Source': '',
    'Destination': '',
    'Transaction ReferenceNo.': '',
    'Payment Mode': '',
    'Trade Margin': '',
    'TradeMarginValue': '',
    'DateOfReciept': '',
    'SaleQuantity': '',
    'AvgPurchasePrice': '',
    'SaleValueAtAvgPurchasePrice': '',
    'BuffingDustValue': '',
    'BookingStatus': '',
    'InterPVCTransaction': '',
    'MAHReference': '',
    'MAHExportedDate': '',
    'Transaction Status': '',
    'Cancellation Remarks': '',
    'BuyBack Type': '',
    'Product Type': '',
    'Product Category': '',
    'Product Sub Category': '',
    'STO Remarks': '',
    'Metal Out Time': '',
    'Metal Out Updated Time': ''
  }

  export const SEARCH_TRANSACRTION_REPORT_FIELDS: TField<any>[] = [
    {
        fieldName: 'dateFrom',
        isVisible: true,
        fieldType: 'date',
        label: 'Date From',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'dateTo',
        isVisible: true,
        fieldType: 'date',
        label: 'Date To',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
  

]